var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import Vue from 'vue';
import { MessageBox } from 'element-ui';
import ImageViewer from 'element-ui/packages/image/src/image-viewer.vue';
import EditMessage from './edit-message.vue';
import { deleteConversation, deleteReply } from '../api';
import { downloadAttachment } from '../download';
import { attachments, authorName, formatTime, isUnread, mediaType, messageHtml, messageText, safeUrl, withinEditHour } from '../utils';
export default Vue.extend({
    name: 'GlobalCommbookMessage',
    components: { EditMessage: EditMessage, ImageViewer: ImageViewer },
    props: {
        record: { type: Object, required: true },
        reply: Boolean,
        conversationId: { type: String, required: true },
        actorId: { type: String, required: true },
        canEditPermission: Boolean,
        canDeletePermission: Boolean
    },
    data: function () {
        return {
            expanded: false,
            editing: false,
            busy: false,
            actionError: '',
            downloading: [],
            previewVisible: false,
            previewSources: [],
            previewIndex: 0
        };
    },
    computed: {
        deleted: function () {
            return Number(this.record.deleted) === 1;
        },
        author: function () {
            return authorName(this.record, this.reply);
        },
        firstName: function () {
            return ((this.reply ? this.record.responseUserFirstname : this.record.pubUserFirstname) ||
                this.author);
        },
        lastName: function () {
            return (this.reply ? this.record.responseUserLastname : this.record.pubUserLastname) || '';
        },
        photo: function () {
            return safeUrl(this.record.photo);
        },
        parentAuthor: function () {
            return Number(this.reply ? this.record.responseUserType : this.record.pubUserType) === 3;
        },
        relationship: function () {
            return this.record.roleName || (this.parentAuthor ? 'Parent' : 'Staff');
        },
        time: function () {
            return formatTime(this.record.createTime);
        },
        unread: function () {
            return isUnread(this.record);
        },
        canManage: function () {
            var authorId = this.reply ? this.record.responseUser : this.record.pubUserId;
            return (!this.deleted &&
                !!this.actorId &&
                String(authorId) === this.actorId &&
                (this.canEditPermission || this.canDeletePermission));
        },
        withinWindow: function () {
            return withinEditHour(this.record);
        },
        canDeleteCurrent: function () {
            return (this.withinWindow &&
                !this.busy &&
                (this.reply || Number(this.record.responseCount || 0) === 0));
        },
        body: function () {
            return this.deleted
                ? ''
                : messageHtml(this.reply ? this.record.response : this.record.message || this.record.plainTextMessage);
        },
        longBody: function () {
            return (!this.deleted &&
                (messageText(this.reply ? this.record.response : this.record.message || this.record.plainTextMessage).length > 600 ||
                    (this.body.match(/<(p|br|li|div)\b/g) || []).length > 10));
        },
        files: function () {
            return attachments(this.record);
        },
        imageSources: function () {
            return this.files.filter(function (file) { return mediaType(file) === 'image'; }).map(function (file) { return file.src; });
        }
    },
    methods: {
        kind: mediaType,
        onBodyClick: function (event) {
            var image = event.target;
            if (!image || image.tagName !== 'IMG')
                return;
            var src = safeUrl(image.getAttribute('src'));
            if (!src)
                return;
            var container = event.currentTarget;
            var images = Array.from(container.querySelectorAll('img')).filter(function (item) {
                return Boolean(safeUrl(item.getAttribute('src')));
            });
            var index = images.indexOf(image);
            if (index < 0)
                return;
            event.preventDefault();
            this.previewSources = images.map(function (item) { return safeUrl(item.getAttribute('src')); });
            this.previewIndex = index;
            this.previewVisible = true;
        },
        closePreview: function () {
            this.previewVisible = false;
            this.previewSources = [];
            this.previewIndex = 0;
        },
        disposePreview: function () {
            // Element UI removes document listeners in hide(), but not when destroyed externally.
            var viewer = this.$refs.imageViewer;
            if (viewer && viewer.deviceSupportUninstall)
                viewer.deviceSupportUninstall();
            this.closePreview();
        },
        onDownload: function (file) {
            return __awaiter(this, void 0, void 0, function () {
                var error_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (this.downloading.includes(file.src))
                                return [2 /*return*/];
                            this.downloading.push(file.src);
                            this.actionError = '';
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, 4, 5]);
                            return [4 /*yield*/, downloadAttachment(file)];
                        case 2:
                            _a.sent();
                            return [3 /*break*/, 5];
                        case 3:
                            error_1 = _a.sent();
                            this.actionError = 'Unable to download attachment. Please try again.';
                            return [3 /*break*/, 5];
                        case 4:
                            this.downloading = this.downloading.filter(function (src) { return src !== file.src; });
                            return [7 /*endfinally*/];
                        case 5: return [2 /*return*/];
                    }
                });
            });
        },
        onCommand: function (command) {
            if (!this.canManage || this.busy)
                return;
            if (command === 'edit' && this.canEditPermission && this.withinWindow) {
                this.actionError = '';
                this.editing = true;
            }
            else if (command === 'delete' && this.canDeletePermission && this.canDeleteCurrent) {
                this.deleteMessage();
            }
        },
        onSaved: function () {
            this.editing = false;
            this.$emit('mutated', { kind: this.reply ? 'reply' : 'topic', action: 'edit' });
        },
        deleteMessage: function () {
            return __awaiter(this, void 0, void 0, function () {
                var error_2, error_3;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            return [4 /*yield*/, MessageBox.confirm(this.reply
                                    ? 'Once deleted, parents cannot see this message and you will not be able to recover the data.'
                                    : 'Once deleted, parents cannot see this message and comments will also be deleted.', this.reply ? 'Delete reply?' : 'Delete conversation?', {
                                    cancelButtonText: 'Cancel',
                                    confirmButtonText: 'Delete',
                                    cancelButtonClass: 'gg_cancel_button',
                                    confirmButtonClass: 'gg_submit_button',
                                    customClass: 'gg_confirm',
                                    showClose: false
                                })];
                        case 1:
                            _a.sent();
                            return [3 /*break*/, 3];
                        case 2:
                            error_2 = _a.sent();
                            return [2 /*return*/];
                        case 3:
                            if (!this.canManage || !this.canDeleteCurrent)
                                return [2 /*return*/];
                            this.busy = true;
                            this.actionError = '';
                            _a.label = 4;
                        case 4:
                            _a.trys.push([4, 9, 10, 11]);
                            if (!this.reply) return [3 /*break*/, 6];
                            return [4 /*yield*/, deleteReply(this.conversationId, String(this.record.id))];
                        case 5:
                            _a.sent();
                            return [3 /*break*/, 8];
                        case 6: return [4 /*yield*/, deleteConversation(this.conversationId)];
                        case 7:
                            _a.sent();
                            _a.label = 8;
                        case 8:
                            this.$emit('mutated', { kind: this.reply ? 'reply' : 'topic', action: 'delete' });
                            return [3 /*break*/, 11];
                        case 9:
                            error_3 = _a.sent();
                            this.actionError =
                                error_3 instanceof Error ? error_3.message : 'Unable to delete. Please try again.';
                            return [3 /*break*/, 11];
                        case 10:
                            this.busy = false;
                            return [7 /*endfinally*/];
                        case 11: return [2 /*return*/];
                    }
                });
            });
        },
        fileIcon: function (file) {
            return ({ video: 'el-icon-video-camera', audio: 'el-icon-headset', file: 'el-icon-document' }[mediaType(file)] || 'el-icon-document');
        }
    }
});
